// generated from 2_109_495 samples

import { z } from "zod";

export const executedWorkflowStepTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::ExecutedWorkflowStep"),
});
